<template lang="pug">
    div
      el-row
        el-col
          h3.title Busbud Historial de descuentos - {{ selectedCountryName }}
      el-row
        el-col
          el-form(:inline="true" label-position="top" size="mini")
            el-form-item(label="País:")
              select-input(:options="countries" :attribute="search" modelKey="country")
            el-form-item(label="Operadores: ")
              select-input(
                :options="filteredBBConciliables"
                :attribute="search"
                modelKey="operators"
                :multiple="true"
              )
            el-form-item(label="Fecha de descuento: ")
              date-input(:inputModel="search" modelKey="discountRange" type="daterange")
            el-form-item(label="Fecha de venta: ")
              date-input(:inputModel="search" modelKey="conciliationRange" type="daterange")
            el-form-item(label="Categoría:")
              select-input(
                :options="categories"
                :attribute="search"
                modelKey="selectedCategories"
                :multiple="true"
              )
            el-form-item(label="Descripción:")
              el-input(v-model="search.description")
            el-form-item.filters__buttons-wrapper
              el-button(
                type="primary"
                icon="el-icon-search"
                @click.prevent="fetchDiscounts(pagination.current)"
              ) FILTRAR
              el-button(
                v-if="canSeeButton()"
                type="success"
                icon="el-icon-download"
                @click.prevent="exportHistoryDiscount(pagination.current)"
              ) EXPORTAR
              el-button(
                v-if="canSeeButton()"
                type="success"
                icon="el-icon-document-add"
                @click.prevent="handleCreateDiscount()"
              ) NUEVO
      el-row
        el-col
          data-table(
            :headers="headers"
            :summaries="summaries"
            :shownSummary="true"
            :items="discounts"
            :shownEdit="false"
            :loading="loading"
          )
            template(slot="additionalActions" slot-scope="scope")
              el-button(
                type="primary"
                size="mini"
                @click.prevent="handleSelectConciliation(scope.row.conciliation_id)"
              ) Conciliación
              el-button(
                v-if="validateDiscountAction(scope.row)"
                type="warning"
                circle
                size="mini"
                icon="el-icon-edit"
                @click.prevent="handleEditDiscount(scope.row)"
              )
              el-button(
                v-if="validateDiscountAction(scope.row)"
                type="danger"
                circle
                size="mini"
                icon="el-icon-delete"
                @click.prevent="handleDestroyDiscount(scope.row)"
              )
          el-pagination(
            layout="prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.perPage"
            :hide-on-single-page="true"
            @current-change="handleCurrentChange"
          )
      el-dialog(:title="dialogForm.title" :visible.sync="dialogForm.visible")
        inline-form(:formAttributes="dialogForm.attributes" ref="dialogForm")
           template(slot="actions" slot-scope="scope")
            el-row(v-if="dateAlertVisible")
              el-col
                h4 ¡Cuidado!
                p La fecha seleccionada es inferior o igual a la fecha actual.
            el-row.inline-form__actions
              el-button(
                type="primary"
                @click.prevent="handleSubmitDiscount()"
                :loading="submitLoading"
              )
                | {{ dialogForm.mode === 'create' ? 'Crear' : 'Actualizar' }}
  </template>

<script>
import SelectInput from '@/components/forms/inputs/SelectInput.vue';
import InlineForm from '@/components/forms/InlineForm.vue';
import DataTable from '@/components/tables/DataTable.vue';
import DateInput from '@/components/forms/inputs/DateInput.vue';

import store from '@/store';
// eslint-disable-next-line import/no-cycle
import FinanceApi from '@/services/apiService';
import DataService from '@/services/dataService';
import DateService from '@/services/dateService';
import permissions from '@/constants/permissions';

// eslint-disable-next-line import/no-cycle
import BBconciliables from '@/mixins/BBconciliables';

import flattenForm from '@/utils/flattenForm';
import formatForm from '@/utils/formatForm';
import setPagination from '@/utils/setPagination';

export default {
  name: 'History',
  components: {
    SelectInput, InlineForm, DataTable, DateInput,
  },
  mixins: [
    BBconciliables,
  ],
  data() {
    return {
      discounts: [],
      summaries: {},
      pagination: {},
      selectedCountry: null,
      search: {
        country: 'CL',
        operators: [],
        discountRange: [
          DateService.getDate(),
          DateService.getDate(),
        ],
        conciliationRange: [],
        categories: [],
        description: '',
      },
      dialogForm: {
        title: '',
        visible: false,
        attributes: {},
        data: {},
        mode: 'create',
      },
      voidDialogForm: { visible: false, data: {}, selectedDiscounts: [] },
      loading: false,
      submitLoading: false,
      channelMessage: '',
    };
  },
  beforeMount() {
    this.fetchDiscounts(1);
  },
  methods: {
    fetchDiscounts(page) {
      this.loading = true;
      FinanceApi.get_bb_discounts(page, this.search).then((data) => {
        this.discounts = data.body.discounts.map((discount) => ({
          ...discount,
          category: this.allCategories
            .find((category) => category.enum === discount.category).value,
          category_id: this.allCategories
            .find((category) => category.enum === discount.category).key,
        }));
        this.summaries = { amount: Number(data.body.summary.amount) };
        setPagination(this, data, page);
        this.loading = false;
      }).catch(() => { this.loading = false; });
      this.selectedCountry = this.search.country;
    },
    exportHistoryDiscount(page) {
      FinanceApi.get_bb_discounts(page, this.search, true).then(() => {
        this.channelMessage = this.$message({
          type: 'success',
          message: 'Se está generando el archivo XLSX, esto puede tardar unos minutos. Al cerrar el navegador o pestaña se perderá la descarga',
          duration: 0,
          showClose: true,
        });
      }).catch((exception) => {
        if (exception.status === 406) {
          this.$notify.error({ title: 'Error', message: 'Aún no se ha realizado alguna búsqueda que pueda ser exportada' });
        } else {
          this.$notify.error({ title: 'Error', message: exception.statusText });
        }
      });
    },
    handleCreateDiscount() {
      const attributes = this._.cloneDeep(this.formAttributes);
      this.dialogForm.attributes = attributes;
      this.dialogForm.title = 'Nuevo descuento';
      this.dialogForm.mode = 'create';
      this.dialogForm.visible = true;
    },
    createDiscount() {
      this.startSubmitLoading();
      this.loading = true;
      const { form } = this.$refs.dialogForm.$refs;
      form.validate((valid) => {
        if (valid) {
          const attributes = formatForm(null, flattenForm(this.dialogForm.attributes.rows));
          const conciliableData = this.dialogForm.attributes.conciliable;

          FinanceApi.create_bb_discount(attributes, conciliableData).then(() => {
            this.channelMessage = this.$message({
              type: 'info',
              message: 'Se está creando el descuento y actualizando la conciliación, esto puede tardar unos minutos.',
              duration: 0,
              showClose: true,
            });
            this.dialogForm.visible = false;
            this.stopSubmitLoading();
          }).catch((exception) => {
            this.$notify.error({ title: 'Error', message: exception.body.message });
            this.stopSubmitLoading();
          });
        } else {
          this.stopSubmitLoading();
        }
      });
    },
    handleCurrentChange(page) {
      this.fetchDiscounts(page);
    },
    handleSelectConciliation(id) {
      store.commit('selectTotal', id);
      this.$router.push({ name: 'bb_conciliation', params: { id } });
    },
    handleDestroyDiscount(row) {
      this.$confirm('¿Estás seguro que deseas eliminar este descuento?', 'Eliminar Descuento', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
      }).then(() => {
        FinanceApi.destroy_bb_discount(row.id).then(() => {
          this.loading = true;
          this.channelMessage = this.$message({
            type: 'info',
            message: 'Se está eliminando el descuento y actualizando la conciliación, esto puede tardar unos minutos.',
            duration: 0,
            showClose: true,
          });
          this.stopSubmitLoading();
        });
      }).catch((exception) => {
        this.stopSubmitLoading();
        this.$notify.error({ title: 'Error', message: exception.body.message });
      });
    },
    handleEditDiscount(data) {
      const attributes = this._.cloneDeep(this.formAttributes);
      attributes.conciliable.id = data.operator_id;
      attributes.conciliable.klass = data.operator_klass;
      const rows = flattenForm(attributes.rows);
      rows.forEach((row) => {
        let rowValue = this._.get(data, row.key);
        if (row.key === 'amount') {
          rowValue = Number(rowValue);
        } else if (row.key === 'operator_id') {
          rowValue = `${data.operator_id}-${data.operator_klass}`;
        } else if (row.key === 'category') {
          rowValue = data.category_id;
        }
        // eslint-disable-next-line no-param-reassign
        row.value = rowValue;
      });
      this.dialogForm.attributes = attributes;
      this.dialogForm.title = 'Editar descuento';
      this.dialogForm.mode = 'edit';
      this.dialogForm.data = { ...data };
      this.dialogForm.visible = true;
    },
    handleSubmitDiscount() {
      if (this.dialogForm.mode === 'create') {
        this.createDiscount();
      } else {
        this.updateDiscount();
      }
    },
    updateDiscount() {
      this.startSubmitLoading();
      this.loading = true;
      const { form } = this.$refs.dialogForm.$refs;

      form.validate((valid) => {
        if (valid) {
          const { id } = this.dialogForm.data;
          const attributes = formatForm(id, flattenForm(this.dialogForm.attributes.rows));
          const conciliableData = this.dialogForm.attributes.conciliable;
          const country = this.selectedCountry;
          FinanceApi.update_bb_discount(attributes, conciliableData, country).then(() => {
            this.channelMessage = this.$message({
              type: 'info',
              message: 'Se está actualizando el descuento y actualizando la conciliación, esto puede tardar unos minutos.',
              duration: 0,
              showClose: true,
            });
            this.dialogForm.visible = false;
            this.stopSubmitLoading();
          }).catch((exception) => {
            this.$notify.error({ title: 'Error', message: exception.body.message });
            this.stopSubmitLoading();
          });
        } else {
          this.stopSubmitLoading();
        }
      });
    },
    validateDiscountAction(row) {
      const discountType = row.discount_type;
      const dayGap = DateService.addDate(row.gap, 'days', null, null);
      const conciliationDate = DateService.getDate(String(row.conciliation_date));
      return conciliationDate > dayGap && discountType === 'manual';
    },
    startSubmitLoading() {
      this.submitLoading = true;
    },
    stopSubmitLoading() {
      this.submitLoading = false;
    },
    canSeeButton() {
      const role = store.state.user.role || '';
      return permissions.FinanceGroup.includes(role);
    },
  },
  channels: {
    PrivateChannel: {
      received(data) {
        if (data.status === 'error') {
          setTimeout(() => {
            this.channelMessage.close();

            this.$message({
              type: 'error',
              message: 'Falló la descarga',
              duration: 7000,
              showClose: true,
            });
          }, 3000);
        } else if (data.file_type === 'update_discount') {
          this.channelMessage.close();
          this.fetchDiscounts(1);
        } else {
          setTimeout(() => {
            this.channelMessage.close();
            this.stopSubmitLoading();
            this.loading = false;
          }, 3000);
        }
      },
    },
  },
  computed: {
    headers() {
      return [
        { key: 'operator', label: 'Operador' },
        { key: 'category', label: 'Categoría' },
        { key: 'description', label: 'Descripción' },
        {
          key: 'discount_date', label: 'Fecha de descuento', type: 'date', format: 'DD-MM-YYYY',
        },
        {
          key: 'conciliation_date', label: 'Fecha de venta', type: 'date', format: 'DD-MM-YYYY',
        },
        { key: 'state', label: 'Estado' },
        {
          key: 'amount', label: 'Monto', type: 'currency', country: this.selectedCountry,
        },
      ];
    },
    countries() {
      return DataService.get_countries();
    },
    categories() {
      return DataService.get_discount_categories(true);
    },
    allCategories() {
      return DataService.get_discount_categories();
    },
    selectedCountryName() {
      return this.countries.find((country) => country.key === this.selectedCountry).value;
    },
    lastFriday() {
      return DateService.addDate(-2, 'days', null);
    },
    dateAlertVisible() {
      const rows = flattenForm(this.dialogForm.attributes.rows || []);
      const discountDateRow = rows.find((row) => row.key === 'discount_date');
      const discountDate = discountDateRow && discountDateRow.value;

      if (!discountDate) { return false; }

      return DateService.getDate(discountDate, null) < DateService.getDate(null, null);
    },
    formAttributes() {
      const $this = this;
      return {
        conciliable: { id: null, klass: '' },
        rows: [
          [
            {
              key: 'country',
              value: 'CL',
              inputType: 'select',
              label: 'País',
              options: this.countries,
              changeMethod(country) {
                const rows = flattenForm($this.dialogForm.attributes.rows);
                const operatorRow = rows.find((row) => row.key === 'operator');
                const amountRow = rows.find((row) => row.key === 'amount');

                $this._.set(operatorRow, 'value', null);
                $this._.set(operatorRow, 'options', $this.filterBBConciliables(country));
                $this._.set(amountRow, 'country', country);
              },
            },
            {
              key: 'operator',
              value: null,
              inputType: 'select',
              label: 'Operador',
              options: this.filteredBBConciliables,
              optionKey: 'idKey',
              changeMethod(idKey) {
                const foundConciliable = $this.getBBConciliable(idKey);

                const conciliableData = $this.dialogForm.attributes.conciliable;

                this._.set(conciliableData, 'id', foundConciliable.id);
                this._.set(conciliableData, 'klass', foundConciliable.klass);
              },
            },
          ],
          [
            {
              key: 'amount', value: 0, inputType: 'currency', label: 'Monto', country: this.selectedCountry,
            },
            {
              key: 'discount_date', value: null, inputType: 'date', label: 'Fecha de descuento',
            },
          ],
          [
            {
              key: 'category', value: 0, inputType: 'select', label: 'Categoría', options: this.categories,
            },
            {
              key: 'description', value: null, inputType: 'textarea', label: 'Descripción',
            },
          ],
        ],
      };
    },
  },
};
</script>
